import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "name" }




export default /*@__PURE__*/_defineComponent({
  __name: 'GradientTitle',
  props: {
    text: {},
    tag: {}
  },
  setup(__props: any) {

const props = __props;

const tag = props.tag || 'h1';

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(tag)), { class: "title" }, {
    default: _withCtx(() => [
      _cache[0] || (_cache[0] = _createElementVNode("span", { class: "prompt" }, "> ", -1)),
      _createElementVNode("span", _hoisted_1, _toDisplayString(props.text), 1),
      _cache[1] || (_cache[1] = _createElementVNode("span", { class: "cursor" }, "_", -1))
    ]),
    _: 1,
    __: [0,1]
  }))
}
}

})